import React, { Component } from 'react'
import axios from "axios";
import "../css/inventory-style.css"
import "../css/general-style.css"
import '../css/table-responsive.css'
import LoadingWindow from '../components/LoadingWindow';
import { getValueCookie } from '../services/cookieService';
import server from "../services/Connection/backEndLink";
import Catalogue3NoPrices from '../components/Catalogue2.0/Catalogue3NoPrices.js';
import Swal from 'sweetalert2';
import { Menu } from "../components/Menu/Menu";
import { AiOutlineSearch, AiOutlineCheckCircle } from "react-icons/ai";

export default class SetProductStatus extends Component {

  constructor(props) {
    super(props)
    this.productLoaderRef = React.createRef();
    this.ModalLoading = React.createRef();
    this.catalogInputRef = React.createRef();

    // Set state
    this.state = {
      searchTerm: '',
      inactiveProducts: [],
      productsLoaded: false,
      selectedProducts: [],
      activeProducts: [],
      newActiveProducts: [],
      filteredProducts: [],
      selectedActiveProducts: [],
      isOnline: navigator.onLine,
    }
  }

  componentDidMount() {
    this.getProducts();
  }


  async getProducts() {
    if (this.state.isOnline) {
      let responseBack;
      const data = {
        idcompany: "3",
        priceLevel: "1",
      };
      const query = "/Items/get-all";

      try {
        const response = await axios.post(`${server.url}${query}`, { data });
        responseBack = response.data;
      } catch (error) {
        console.error("Error getting products:", error);
        return; // detener la ejecución
      }

      // Validar que hay datos antes de continuar
      if (!responseBack || !responseBack.data) {
        console.warn("Empty or invalid response");
        return;
      }

      const { inactiveProducts, activeProducts } = responseBack.data.reduce(
        (acc, p) => {
          if (p.inactiveItem === 'Y') acc.inactiveProducts.push(p);
          else if (p.inactiveItem === 'N') acc.activeProducts.push(p);
          return acc;
        },
        { inactiveProducts: [], activeProducts: [] }
      );

      this.setState({
        inactiveProducts,
        activeProducts,
        filteredProducts: inactiveProducts
      });
    }
  }


  selectProduct(product) {
    const newProduct = { itemCode: product.itemCode, InactiveItem: 'N' };
    if (!product.pendingProcess) {
      this.setState(prevState => {
        const isAlreadySelected = prevState.selectedProducts.some(
          p => p.itemCode === newProduct.itemCode
        );
        let updatedProducts;
        if (isAlreadySelected) {
          // Remove the product if it exists
          updatedProducts = prevState.selectedProducts.filter(
            p => p.itemCode !== newProduct.itemCode
          );
        } else {
          // Add product
          updatedProducts = [...prevState.selectedProducts, newProduct];
        }
        return { selectedProducts: updatedProducts };
      });
    }
  }

  // Change the hover if a product was selected
  isSelected(product) {
    return this.state.selectedProducts.some(p => p.itemCode === product.itemCode)
  }

  isPendingProducts() {
    return this.state.inactiveProducts.some(p => 'pendingProcess' in p)
  }

  removeNewProduct(product) {
    this.setState(prevState => {
      let updatedInactiveProducts = prevState.inactiveProducts.filter(
        p => p.itemCode !== product.itemCode
      );
      return { inactiveProducts: updatedInactiveProducts }
    })
  }

  async requestSetProduct(productList, setValue, textGroup) {
    let payload = { data: { items: [] } }
    const userResponse = await Swal.fire({
      title: textGroup.title,
      text: "Do you want to continue? ",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, continue',
      cancelButtonText: 'No, cancel',
    })
    if (userResponse.isConfirmed) {
      for (const p of productList) {
        payload.data.items.push({ ItemCode: p.itemCode, InactiveItem: setValue })
      }
      const query = "/Items/updateStatus"
      await axios.post(`${server.url}${query}`, payload).then(
        response => {
          if (response.data.status.code === 1) {
            Swal.fire({
              icon: "success",
              title: textGroup.confirmTitle,
              showConfirmButton: false,
              timer: 1500
            });
            if (setValue === 'Y') {
              this.setState(prev => ({ activeProducts: [...prev.newActiveProducts] }));
              this.setState({selectedActiveProducts: []})
            } else {
             this.updateInactiveProducts()
            }
          } else {
            Swal.fire({
              icon: "error",
              title: textGroup.errorTitle,
            });
          }
        }
      ).catch(error => {
        console.log(error)
        // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
      })
    }
    if (this.catalogInputRef.current) {
      this.catalogInputRef.current.cleanSearchInput();
    }
  }

  setAsInactive = async () => {
    const productList = this.state.inactiveProducts.filter(p => p.pendingProcess === true);
    const setValue = "Y";
    const textGroup = {
      title: "These products will be set as inactive",
      confirmTitle: "The products were set as inactive successfully",
      errorTitle: "It was not possible to set these products. Please try again."
    }
    this.requestSetProduct(productList, setValue, textGroup)
  }

  async setAsActive() {
    const productList = this.state.selectedProducts;
    const setValue = "N";
    const textGroup = {
      title: "These products will be reactivated",
      confirmTitle: "The products were set as active successfully",
      errorTitle: "It was not possible to reactivate these products. Please try again."
    }

    this.requestSetProduct(productList, setValue, textGroup)
  }

  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  filterProducts = () => {
    const { searchTerm, inactiveProducts } = this.state;
    const filtered = inactiveProducts.filter(product =>
      product.abbreviatedDesc.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.itemCode.toLowerCase().includes(searchTerm.toLowerCase())
    );
    this.setState({ filteredProducts: filtered });
  }
  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.filterProducts();
    }
  }

  handleSearchButtonClick = () => {
    this.filterProducts();
  }

  updateProductStatus = (newActiveProducts) => {
    this.setState({newActiveProducts})
  }

  updateInactiveProducts = () => {
    const {filteredProducts, selectedProducts} = this.state;
    const newInactiveProductIds = new Set(selectedProducts.map(p => p.itemCode));
    const filteredInactiveProducts = filteredProducts.filter(p => !newInactiveProductIds.has(p.itemCode));
    this.setState({filteredProducts: filteredInactiveProducts, selectedProducts: [],})
  }


  render() {
    const { searchTerm, filteredProducts } = this.state;
    return (
      <div className='InventoryInfo lobbyContainer'>
        <Menu Refresh={this.state.Refresh} Father={this} />
        <LoadingWindow ref={this.ModalLoading} />

        <div className='text-center my-5'>
          <h2 className='display-5 fw-bold inventory-title'>Products Status</h2>
        </div>

        <div className="container-fluid">
          <div className="row justify-content-center">
            {/* All items */}
            <div hidden={this.state.activeProducts.length === 0} className='col-sm-12 col-md-6 col-lg-6 order-1 mb-3'>
              <div className="card inventory-card">
                <div className="card-body">
                  <Catalogue3NoPrices ref={this.productLoaderRef} PriceLevel={this.state.PriceLevel} nombrePadre={'ProductInformation'} Array={'Catalogue'} Padre={this} titleButton='Open Catalogue' needPrice={getValueCookie('SalesPerson') === '0010' ? false : true} needCost={getValueCookie('SalesPerson') === '0010' ? true : false} productList={'ProductList'} activeProducts={this.state.activeProducts} setAsInactive={this.setAsInactive} updateProductStatus={this.updateProductStatus}/>
                </div>
              </div>
            </div>

            {/* Inactive items */}
            <div hidden={this.state.inactiveProducts.length === 0} className="col-sm-12 col-md-6 col-lg-6 order-3 order-md-3 order-lg-2">
              <div className="card inventory-card">
                <div className="card-body">
                  <div className='row' style={{ maxHeight: '87vh', minHeight: '87vh', overflow: 'auto' }}>
                    <div className='col-12 mb-4' style={{ backgroundColor: '#fff' }}>
                      <div className='d-flex align-items-center justify-content-between mb-4'>
                        <h5 className='orangeText mb-0 d-flex align-items-center'>
                          Inactive Products
                          {/* Selected badge */}
                          {this.state.selectedProducts.length > 0 && (
                            <span className="badge badgeRedBg ms-2">
                              {this.state.selectedProducts.length}
                            </span>
                          )}
                        </h5>

                        {/* Save button */}
                        {this.state.selectedProducts.length > 0 && (
                          <button type="button" className="btn btn-sm blueBackground d-flex align-items-center" onClick={() => this.setAsActive()}>
                            <AiOutlineCheckCircle title="Desactivar" size={20} className='me-2' />
                            Activate
                          </button>
                        )}
                      </div>

                      <div className="input-group flex-nowrap mb-4">
                        <button className="btn blueButton" onClick={this.handleSearchButtonClick}>
                          <AiOutlineSearch title="Filtrar" size={20} />
                        </button>

                        <input className='form-control w-75 inputResize' placeholder='Search product' autoComplete="off" value={searchTerm} onChange={this.handleSearchChange} onKeyDown={this.handleKeyPress} />
                      </div>
                    </div>

                    {
                      filteredProducts.map((product, i) => (
                        <div key={i} className='col-sm-6 col-md-4 my-2' onClick={() => this.selectProduct(product)}>
                          <div
                            className={`card cartaHover font-family-arial ${this.isSelected(product) ? 'selected-product-red' : ''} ${product.pendingProcess ? 'new-product-selected' : ''}`}>
                            <div className="card-body text-center">
                              <div className="col-12 imgC d-flex align-items-center justify-content-center">
                                <img key={product.itemURLImage} src={product.itemURLImage ? `${product.itemURLImage}` : "./assets/notavailable.png"} alt="Card cap" className='imgC' />
                                {/* <IoClose hidden={!product.pendingProcess} size={40} className="trash-icon-float" onClick={() => this.removeNewProduct(product)} /> */}
                              </div>

                              <p>
                                <span className="badge darkPurpleBackground mt-2 px-4">{product.itemCode}</span>
                              </p>
                              <h5 className="card-text fs-6" style={{ minHeight: 75 }}>{product.abbreviatedDesc}</h5>
                            </div>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
            {/* Cataloge and action. buttons */}
          </div>
        </div>
      </div>
    )
  }
}
